/////////////
// RANGES //
///////////

const CLOSE_RANGE = {
    "min": 1,
    "max": 1,
    "orthogonal": true,
    "diagonal": false,
}

const MID_RANGE = {
    "min": 2,
    "max": 2,
    "orthogonal": true,
    // "diagonal": true,
    "diagonal": false,
    "type": "arc",
}

const DIAG_MID_RANGE = {
    "min": 2,
    "max": 2,
    "orthogonal": true,
    "diagonal": true,
    "type": "arc",
}

const LONG_RANGE = {
    "min": 2,
    "max": 4,
    "orthogonal": true,
    "diagonal": false,
    "type": "arc",
}

const LINE_RANGE = {
    "min": 1,
    "max": 5,
    "orthogonal": true,
    "diagonal": false,
    "type": "line",
}

const LONGEST_RANGE = {
    "min": 2,
    "max": 5,
    "orthogonal": true,
    "diagonal": false,
    "type": "arc",
}

/////////////
// SKILLS //
///////////

const skills = {}
export default skills

skills["attack"] = {
    "type": "attack",
    "animation": "strike",
    "range": CLOSE_RANGE,
    "power": 1,
    "calculateDeltastages": function({performerKey, effectKey, stage, position}) {
        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)

        const deltastages = []
        deltastages.push({"annotation": {"type": "swing", "unit": "robot", "direction": direction, "startPosition": performer.position, "endPosition": position, "unitKey": performer.key}, "units": {[performerKey]: {}}})

        const target = findUnitAtPosition(stage, position)
        if(target != undefined) {
            const baseDamage = -1 * (this.power + performer.power)

            deltastages.push({
                "annotation": {"type": "inflict damage", "direction": direction},
                "units": {[target.key]: {"health": -1}}
            })
        }

        return deltastages
    },
    "name": "Strike",
    "description": function() {
        return "Deals " + this.power + " damage."
    },
}

skills["suplex"] = {
    "type": "attack",
    "animation": "strike",
    "range": CLOSE_RANGE,
    // "canTarget": function({performerKey, stage, position}) {
    //     const performer = stage.units[performerKey]
    //     const target = findUnitAtPosition(stage, position)
    //     if(target == undefined) return false
    //     // if(target.affiliation != performer.affiliation) return false
    //     const previousPosition = target.position
    //     const direction = Geometry.direction(target.position, performer.position)
    //     const nextDirection = Geometry.multiply(direction, -2)
    //     const nextPosition = Geometry.add(previousPosition, nextDirection)
    //     return hasCollision(stage, previousPosition, nextPosition) == false
    // },
    "calculateDeltastages": function({performerKey, stage, position}) {
        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)

        const deltastages = []

        deltastages.push({
            "annotation": {"type": "swing", "direction": direction, "performerKey": performerKey, "unit": "flipper"},
            "units": {[performer.key]: {}}
        })

        const target = findUnitAtPosition(stage, position)
        if(target != undefined) {
            const nextDirection = Geometry.multiply(direction, -2)
            const nextPosition = Geometry.add(target.position, nextDirection)

            if(hasCollision(stage, performer.position, nextPosition, {
                "isIgnoringLedges": true, "isIgnoringWallEdges": true,
            }) == false) {
                deltastages.push({
                    "annotation": {"type": "suplex", "direction": direction},
                    "units": {[target.key]: {"position": nextDirection}}
                })
            } else {
                deltastages.push({
                    "annotation": {"type": "nudge", "direction": Geometry.flip(direction), "unitKey": target.key},
                })
            }
        }

        return deltastages
    },
    "name": "Suplex",
    "description": "Repositions to the opposite side.",
}

skills["burst"] = {
    "type": "attack",
    "animation": "farstrike",
    "range": LONGEST_RANGE,
    "calculateDeltastages": function({performerKey, stage, position}) {
        const performer = stage.units[performerKey]
        const direction = Geometry.direction(performer.position, position)

        const deltastages = []

        deltastages.push({
            "annotation": {
                "type": "cast projectile",
                "unitKey": performer.key,
                "startPosition": performer.position,
                "endPosition": position
            }
        })

        const target = findUnitAtPosition(stage, position)
        if(target != undefined) {
            deltastages.push({
                "annotation": {"type": "heal", "direction": direction},
                "units": {[target.key]: {"health": +1}}
            })
        }

        [{"x": +1}, {"x": -1}, {"y": +1}, {"y": -1}].forEach((direction) => {
            const nextPosition = Geometry.add(position, direction)
            if(World.hasCollision(stage.world, position, nextPosition, {"isIgnoringLedges": true})) {
                return
            }
            deltastages.push({
                "annotation": {"type": "burst", "direction": direction, "startingPosition": position}
            })
            const unit = findUnitAtPosition(stage, nextPosition)
            const nextnextPosition = Geometry.add(nextPosition, direction)
            if(unit != undefined) {
                if(World.hasCollision(stage.world, nextPosition, nextnextPosition, {"isIgnoringLedges": true})
                || findUnitAtPosition(stage, nextnextPosition) != undefined) {
                    deltastages.push({
                        "annotation": {"type": "nudge", "direction": direction, "unitKey": unit.key},
                        "units": {[unit.key]: {"health": +1}}
                    })
                } else {
                    deltastages.push({
                        "annotation": {"type": "push", "direction": direction},
                        "units": {[unit.key]: {"position": direction, "health": +1}}
                    })
                }
            }
        })

        return deltastages
    },
    "name": "Thunderwave",
    "description": "Throws a projectile that pushes adjacent units away.",
}

skills["smite"] = {
    "type": "attack",
    "animation": "strike",
    "range": CLOSE_RANGE,
    "distance": 2,
    "calculateDeltastages": function({performerKey, stage, position}) {
        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)
        const deltastages = []

        deltastages.push({
            "annotation": {"type": "swing", "direction": direction, "unit": "pusher"},
            "units": {[performer.key]: {}}
        })

        const target = findUnitAtPosition(stage, position)
        if(target != undefined) {
            let distance = 0
            let vector = {"x": 0, "y": 0}
            for(let i = 0; i < this.distance; i += 1) {
                if(hasCollision(stage, Geometry.add(target.position, vector), Geometry.add(Geometry.add(target.position, vector), direction), {"isIgnoringLedges": true}) == false) {
                    vector = Geometry.add(vector, direction)
                    distance += 1
                    continue
                } else {
                    break
                }
            }
            if(distance == 0) {
                deltastages.push({
                    "annotation": {"type": "nudge", "distance": distance, "direction": direction, "expectedDistance": this.distance, "unitKey": target.key},
                })
            }
            if(distance > 0) {
                deltastages.push({
                    "annotation": {"type": "push", "distance": distance, "direction": direction, "expectedDistance": this.distance},
                    "units": {
                        [target.key]: {
                            "position": vector, // relative?
                            // "health": +1,
                        }
                    }
                })
            }
        }

        return deltastages
    },
    "name": "Smite",
    "description": function() {
        return "Pushes " + this.distance + " tiles!"
    }
}

skills["hook"] = {
    "type": "attack",
    "animation": "hook",
    "range": LINE_RANGE,
    "canTarget": function({performerKey, stage, position}) {
        const performer = stage.units[performerKey]
        if(Geometry.equals(performer.position, position)) return false
        return true
    },
    "calculateDeltastages": function({performerKey, stage, position}) {
        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)

        const deltastages = []

        deltastages.push({
            "annotation": {"type": "swing", "direction": direction, "performerKey": performerKey},
        })

        let distance = 0
        let vector = {"x": 0, "y": 0}
        for(let i = 0; i < this.range.max; i += 1) {
            if(hasCollision(stage, Geometry.add(performer.position, vector), Geometry.add(Geometry.add(performer.position, vector), direction), {"isIgnoringLedges": true}) == false) {
                vector = Geometry.add(vector, direction)
                distance += 1
                continue
            } else {
                break
            }
        }

        const previousPosition = Geometry.add(performer.position, vector)
        const nextPosition = Geometry.add(previousPosition, direction)

        if(distance == 0) {
            const target = findUnitAtPosition(stage, nextPosition)
            if(target != undefined) {
                deltastages.push({
                    "annotation": {
                        "type": "nudge",
                        "direction": direction,
                        "distance": distance,
                        "alphaposition": performer.position,
                        "omegaposition": previousPosition,
                        "targetKey": performer.key,
                        "deltaposition": vector,
                        "performerKey": performerKey,
                        "unitKey": target.key
                    },
                })
            }
        }

        if(distance > 0) {
            if(World.hasCollision(stage.world, previousPosition, nextPosition, {"isIgnoringLedges": true}) == true) {
                deltastages.push({
                    "annotation": {"type": "pull-self", "swingdirection": Geometry.direction(vector), "distance": distance, "alphaposition": performer.position, "omegaposition": previousPosition, "targetKey": performer.key, "deltaposition": vector, "performerKey": performerKey},
                    "units": {
                        [performer.key]: {"position": vector},
                    }
                })
            } else if(findUnitAtPosition(stage, nextPosition) != undefined) {
                const target = findUnitAtPosition(stage, nextPosition)
                deltastages.push({
                    "annotation": {"type": "pull-target", "swingdirection": Geometry.direction(vector), "distance": distance + 1, "alphaposition": performer.position, "omegaposition": nextPosition, "targetKey": target.key, "deltaposition": Geometry.flip(vector), "performerKey": performerKey},
                    "units": {
                        [target.key]: {"position": Geometry.flip(vector)},
                    }
                })
            } else {
                deltastages.push({
                    "annotation": {"type": "pull-none", "swingdirection": Geometry.direction(vector), "distance": distance, "alphaposition": performer.position, "omegaposition": nextPosition, "deltaposition": vector, "performerKey": performerKey},
                })
            }
        }

        return deltastages
    },
    "name": "Pull",
    "description": "Pulls an ally backwards [1] tile.",
}

//////////////
// UTILITY //
////////////

// https://gist.github.com/ehgoodenough/e329ceb141294e6b0f1fd375acf973fe

import World  from "@frog/source/models/World.js"

import shortid from "shortid"

import Elements from "@frog/source/data/elements.js"
import Geometry from "@frog/source/utility/Geometry.js"
import Keyset from "@frog/source/utility/Keyset.js"
import Unit from "@frog/source/models/Unit.js"
import Step from "@frog/source/models/Step.js"

function findUnitAtPosition(stage, nextPosition) {
    const unit = Keyset.find(stage.units, (unit) => {
        return unit.position.x == nextPosition.x
            && unit.position.y == nextPosition.y
            && unit.position.z == nextPosition.z
            && unit.isDead != true
    })
    return unit
}

function hasCollision(stage, previousPosition, nextPosition, options) {
    if(World.hasCollision(stage.world, previousPosition, nextPosition, options)) {
        return true
    }
    if(findUnitAtPosition(stage, nextPosition)) {
        return true
    }
    return false
}

const directions = [{"x": +1}, {"x": -1}, {"y": +1}, {"y": -1}]
// TODO: merge this with utilities/Directions.js? Pull them from Geometry.north/etc?

function raycast({stage, position, direction, distance = Infinity}) {
    let currentDistance = 0
    let currentVector = {"x": 0, "y": 0}
    let currentPosition = position
    while(currentDistance < distance == true) {
        if(World.hasCollision(stage.world, currentPosition, Geometry.add(currentPosition, direction))) {
            return {
                "collision": {
                    "position": Geometry.add(currentPosition, direction),
                    "type": "world"
                },
                "ray": {
                    "startPosition": position,
                    "endPosition": currentPosition,
                    "distance": currentDistance,
                    "direction": direction,
                    "vector": currentVector,
                }
            }
        }
        const unit = findUnitAtPosition(stage, Geometry.add(currentPosition, direction))
        if(unit != undefined) {
            return {
                "collision": {
                    "position": Geometry.add(currentPosition, direction),
                    "unit": unit,
                },
                "ray": {
                    "startPosition": position,
                    "endPosition": currentPosition,
                    "distance": currentDistance,
                    "direction": direction,
                    "vector": currentVector,
                }
            }
        }
        currentVector = Geometry.add(currentVector, direction)
        currentPosition = Geometry.add(currentPosition, direction)
        currentDistance += 1
    }
    return {
        "ray": {
            "startPosition": position,
            "endPosition": currentPosition,
            "distance": currentDistance,
            "direction": direction,
            "vector": currentVector,
        }
    }
}

function calculateTrapPositions({stage, position, range}) {
    const positions = []

    if(range == undefined) return positions

    range.directions = range.directions || directions
    range.directions.forEach((direction) => {
        const distance = Math.abs(direction.x || 0) + Math.abs(direction.y || 0)
        let previousPosition = position
        for(let i = range.min; i <= range.max; i += 1) {
            const nextPosition = Geometry.add(position, Geometry.multiply(direction, i / distance))

            if(range.type != "arc"
            && World.hasCollision(stage.world, previousPosition, nextPosition) == true) {
                return
            }

            const unit = findUnitAtPosition(stage, nextPosition)
            if(unit != undefined) {
                // Do not pierce through boxes. ??? BOMBER
                if(unit.family == "box") { // IS SOFT BOX BLOCK
                    return
                }
            }

            positions.push(nextPosition)
            previousPosition = nextPosition
        }
    })

    // let chargeAmount = 0
    // let chargeVector = {"x": 0, "y": 0}
    // let chargePosition = position
    // while(chargeAmount < distance == true
    // // && hasCollision(stage, chargePosition, Geometry.add(chargePosition, direction)) == false) {
    // && World.hasCollision(stage.world, chargePosition, Geometry.add(chargePosition, direction)) == false) {
    //     chargeVector = Geometry.add(chargeVector, direction)
    //     chargePosition = Geometry.add(position, chargeVector)
    //     chargeAmount += 1
    //     positions.push(chargePosition)
    // }
    return positions
}

function recalculateEffects(stage, unit, deltaunit) {
    deltaunit.effects = deltaunit.effects || {}
    let position = deltaunit.position
    // console.log(deltaunit)
    if(deltaunit.mode == "relative"
    || deltaunit.mode == undefined) { // defaulting to relative
        position = Geometry.add(unit.position, deltaunit.position)
        // TODO: if this was a reaction, we could just piggyback off
        // of the delta computed stuff. This assume it was a reaction
        // system outside of the skill and in the action calculation,
        // and not just layers of layers of logic in the skills like
        // it currently is.
    }
    Keyset.forEach(unit.effects, (effect, effectKey) => {
        if(effect.type == "trap" || effect.type == "traplike") {
            deltaunit.effects[effectKey] = {
                "positions": calculateTrapPositions({
                    "stage": stage,
                    "range": effect.range,
                    "position": position
                })
            }
        }
    })
}

// SKILL SCHEMA v4 MUST SUPPORT:
// deconstructed parameter signature for target, performer and action.
// only being passed performerKey and action, not the explicit target keys.
// being able to be run on tile without a unit to target, returning nothing.
// must declare key in results. cannot rely on old target/performer shorcuts.
// must declare key relative to stage schema, so deltastage.units[key] = deltaunit
// can return a single delta or an array of deltas for separating into animations
// must handle reactions like traps or death?

class Range {
    static copy(a) {
        const b = {}
        for(let key in a) {
            b[key] = a[key]
        }
        return b
    }
}

const elements = {
    "fire-type": {"element": "fire"},
    "water-type": {"element": "water"},
    "grass-type": {"element": "grass"},
    "ground-type": {"element": "ground"},
    "metal-type": {"element": "metal"},
    "lightning-type": {"element": "lightning"},
}

const ranges = {
    "close-range": {"range": CLOSE_RANGE},
    "mid-range": {"range": MID_RANGE, "animation": "farstrike"},
    "long-range": {"range": LONG_RANGE, "animation": "farstrike"},
    "diag-mid-range": {"range": DIAG_MID_RANGE, "animation": "farstrike"},
}

const potencies = {
    "mad-potent": {"potency": "mad"},
    "mild-potent": {"potency": "mild"},
}

// TODO: ARE WE REALLY making individual
// dictionaries for each and every stat?
const timers = {
    "3-timer": {"timer": 3},
    "2-timer": {"timer": 2},
    "1-timer": {"timer": 1},
}

const targets = {
    "enemy-only-target": {
        "canTarget": function({performerKey, stage, position}) {
            const performer = stage.units[performerKey]
            const target = findUnitAtPosition(stage, position)
            if(target == undefined) return false
            return target.affiliation != performer.affiliation
        }
    },
    "ally-only-target": {
        "canTarget": function({performerKey, stage, position}) {
            const performer = stage.units[performerKey]
            const target = findUnitAtPosition(stage, position)
            if(target == undefined) return false
            return target.affiliation == performer.affiliation
        }
    },
    "enemy-or-empty-target": {
        "canTarget": function({performerKey, stage, position}) {
            const performer = stage.units[performerKey]
            const target = findUnitAtPosition(stage, position)
            if(target == undefined) return true
            return target.affiliation != performer.affiliation
        }
    },
    "ally-or-empty-target": {
        "canTarget": function({performerKey, stage, position}) {
            const performer = stage.units[performerKey]
            const target = findUnitAtPosition(stage, position)
            if(target == undefined) return true
            return target.affiliation == performer.affiliation
        }
    },
    "only-target": {
        "canTarget": function({performerKey, stage, position}) {
            const performer = stage.units[performerKey]
            const target = findUnitAtPosition(stage, position)
            if(target == undefined) return false
            return true
        }
    },
    "all-target": {
        "canTarget": function({performerKey, stage, position}) {
            return true
        }
    },
}

skills.get = function(skillKey) {
    if(skillKey == undefined) {
        return undefined
    }
    if(skills[skillKey] != undefined) {
        return skills[skillKey]
    }

    let skill = {}
    skillKey.split(" ").forEach((skillPart) => {
        if(skills[skillPart] != undefined) {
            skill = Keyset.merge(skill, skills[skillPart])
        }
        if(skillPart.endsWith("-power")) {
            skill = Keyset.merge(skill, {"power": parseInt(skillPart)})
        }
        if(skillPart.endsWith("-type")) {
            skill = Keyset.merge(skill, elements[skillPart] || {})
        }
        if(skillPart.endsWith("-range")) {
            skill = Keyset.merge(skill, ranges[skillPart] || {})
        }
        if(skillPart.endsWith("-potent")) {
            skill = Keyset.merge(skill, potencies[skillPart] || {})
        }
        if(skillPart.endsWith("-timer")) {
            skill = Keyset.merge(skill, timers[skillPart] || {})
        }
        if(skillPart == "inflictsFlinch") { // ONLY WORKS WITH STRIKE RIGHT NOW
            skill = Keyset.merge(skill, {"inflictsFlinch": true})
        }
        if(skillPart.endsWith("-target")) {
            skill = Keyset.merge(skill, targets[skillPart])
        }
    })
    skills[skillKey] = skill
    return skill
}

// //////////////////////
// // From Groknaught //
// ////////////////////
//
// skills["strike"] = {
//     "type": "attack",
//     "animation": "strike",
//     "information": "strike",
//     "range": CLOSE_RANGE,
//     "power": 1,
//     "calculateDeltastages": function({performerKey, effectKey, stage, position}) {
//         const performer = stage.units[performerKey]
//         const direction = Geometry.direction(position, performer.position)
//
//         const deltastages = []
//         deltastages.push({
//             "annotation": {"type": "swing", "direction": direction, "startPosition": performer.position, "endPosition": position, "unitKey": performer.key},
//             "units": {[performerKey]: {}}
//         })
//
//         // if(effectKey != undefined) {
//         //     deltastages.push({
//         //         "units": {
//         //             [performerKey]: {
//         //                 "effects": {
//         //                     [effectKey]: undefined
//         //                 }
//         //             }
//         //         }
//         //     })
//         // }
//
//         const target = findUnitAtPosition(stage, position)
//         if(target != undefined) {
//             const baseDamage = -1 * (this.power + performer.power)
//             const elementalDamage = Elements.getDamage(target.element, this.element || performer.element, this.potency)
//             const elementalEffectiveness = Elements.getEffectiveness(target.element, this.element || performer.element)
//
//             deltastages.push({
//                 "annotation": {"type": "inflict damage", "direction": direction, "effectiveness": elementalEffectiveness},
//                 "units": {
//                     [target.key]: {
//                         "health": baseDamage + elementalDamage,
//                     }
//                 }
//             })
//
//             if(this.inflictsFlinch == true) {
//                 deltastages.push({
//                     "units": {
//                         [target.key]: {
//                             "effects": {
//                                 "flinch": {"type": "flinch", "timer": 1}
//                             }
//                         }
//                     }
//                 })
//             }
//         }
//
//         return deltastages
//     },
//     "name": "Strike",
//     "description": "Deals damage.",
// }
//
// const xskills = {}
// xskills["suplex"] = {
//     "type": "attack",
//     "animation": "strike",
//     "range": CLOSE_RANGE,
//     "power": 1,
//     "canTarget": function({performerKey, stage, position}) {
//         const performer = stage.units[performerKey]
//         const target = findUnitAtPosition(stage, position)
//         if(target == undefined) return false
//         if(target.affiliation != performer.affiliation) return false
//         const previousPosition = target.position
//         const direction = Geometry.direction(target.position, performer.position)
//         const nextDirection = Geometry.multiply(direction, -2)
//         const nextPosition = Geometry.add(previousPosition, nextDirection)
//         return hasCollision(stage, previousPosition, nextPosition) == false
//     },
//     "calculateDeltastages": function({performerKey, stage, position}) {
//         const performer = stage.units[performerKey]
//         const direction = Geometry.direction(position, performer.position)
//
//         const deltastages = []
//
//         deltastages.push({
//             "annotation": {"type": "swing", "direction": direction},
//             "units": {[performer.key]: {}}
//         })
//
//         const target = findUnitAtPosition(stage, position)
//
//         if(target == undefined) {
//             return deltastages
//         }
//
//         const previousPosition = target.position
//         const nextDirection = Geometry.multiply(direction, -2)
//         const nextPosition = Geometry.add(previousPosition, nextDirection)
//
//         if(target != undefined
//         && hasCollision(stage, previousPosition, nextPosition) == false) {
//             deltastages.push({
//                 "annotation": {"type": "suplex", "direction": direction},
//                 "units": {[target.key]: {"position": nextDirection}}
//             })
//             recalculateEffects(stage, target, deltastages[deltastages.length-1].units[target.key])
//         }
//
//         return deltastages
//     },
//     "name": "Suplex",
//     "description": "Repositions an ally to the opposite side.",
// }
//
// skills["flexstrike"] = {
//     "type": "attack",
//     "animation": "strike",
//     "range": CLOSE_RANGE,
//     "power": 1,
//     "canTarget": function({performerKey, stage, position}) { // TODO: we aren't letting you attack allies?
//         const target = findUnitAtPosition(stage, position)
//         const performer = stage.units[performerKey]
//         if(target != undefined) {
//             return target.affiliation != performer.affiliation
//         }
//         return true
//     },
//     "calculateDeltastages": function({performerKey, stage, position}) {
//         const performer = stage.units[performerKey]
//         const direction = Geometry.direction(position, performer.position)
//
//         const deltastages = []
//
//         const target = findUnitAtPosition(stage, position)
//         if(target != undefined) {
//             deltastages.push({
//                 "annotation": {"type": "swing", "direction": direction},
//                 "units": {[performerKey]: {}}
//             })
//
//             const baseDamage = -1 * (this.power + performer.power)
//             // const elementalDamage = Elements.getDamage(target.element, this.element || performer.element, this.potency)
//
//             deltastages.push({
//                 "annotation": {"type": "bump", "direction": direction},
//                 "units": {
//                     [target.key]: {
//                         "health": baseDamage + elementalDamage,
//                     }
//                 }
//             })
//         }
//
//         const range = Range.copy(this.range)
//         range.directions = [direction]
//         deltastages.push({
//             "annotation": {"type": "readying-trap"},
//             "units": {
//                 [performer.key]: {
//                     "effects": [
//                         {
//                             "timer": 2,
//                             "type": "trap",
//                             // ...
//                             "range": range,
//                             "actionMark": stage.actionMark,
//                             "skillKey": "strike" + " " + (this.potency || "standard") + "-potent" + " " + (this.power || 0) + "-power" + " inflictsFlinch",
//                             "positions": calculateTrapPositions({
//                                 "stage": stage,
//                                 "range": range,
//                                 "position": performer.position,
//                             }),
//                         }
//                     ]
//                 }
//             }
//         })
//
//         return deltastages
//     },
//     "name": "Strike",
//     "description": "Deals damage or lays trap.",
// }
//
// skills["counterattack"] = {
//     "type": "counterattack",
//     "animation": "strike",
//     "information": "none",
//     "range": CLOSE_RANGE,
//     "power": 1,
//     "calculateDeltastages": function({performerKey, stage, position}) {
//         const performer = stage.units[performerKey]
//         const direction = Geometry.direction(position, performer.position)
//
//         const deltastages = []
//         deltastages.push({
//             "annotation": {"type": "swing", "direction": direction, "startPosition": performer.position, "endPosition": position, "unitKey": performer.key},
//             "units": {[performerKey]: {}}
//         })
//
//         const target = findUnitAtPosition(stage, position)
//         if(target != undefined) {
//             const baseDamage = -1 * (this.power + performer.power) || 0
//             const elementalDamage = Elements.getDamage(target.element, this.element || performer.element, this.potency)
//             const elementalEffectiveness = Elements.getEffectiveness(target.element, this.element || performer.element)
//
//             deltastages.push({
//                 "annotation": {"type": "inflict damage", "direction": direction, "effectiveness": elementalEffectiveness},
//                 "units": {[target.key]: {"health": baseDamage + elementalDamage}}
//             })
//         }
//
//         return deltastages
//     },
//     "name": "Counterstrike",
//     "description": "Deals damage when damaged.",
// }
//
// skills["push"] = {
//     "type": "attack",
//     "animation": "strike",
//     "range": CLOSE_RANGE,
//     "power": 1,
//     "canTarget": function({performerKey, stage, position}) {
//         const performer = stage.units[performerKey]
//         const target = findUnitAtPosition(stage, position)
//         if(target == undefined) return false
//         if(target.affiliation != performer.affiliation) return false
//         return true
//     },
//     "calculateDeltastages": function({performerKey, stage, position}) {
//         const performer = stage.units[performerKey]
//         const direction = Geometry.direction(position, performer.position)
//
//         const deltastages = []
//
//         deltastages.push({
//             "annotation": {"type": "swing", "direction": direction},
//             "units": {[performer.key]: {}}
//         })
//
//         const target = findUnitAtPosition(stage, position)
//
//         if(target != undefined
//         && hasCollision(stage, target.position, Geometry.add(target.position, direction)) == false) {
//             deltastages.push({
//                 "annotation": {"type": "push", "direction": direction},
//                 "units": {[target.key]: {"position": direction}}
//             })
//             recalculateEffects(stage, target, deltastages[deltastages.length-1].units[target.key])
//         }
//
//         // Removed: damage to the pushed unit
//         // Removed: damaged to any colliding units
//         // Removed: support for pushing multiple tiles.
//
//         return deltastages
//     },
//     "name": "Push",
//     "description": function() {
//         return "Pushes an ally [" + this.power + "] tile" + (this.power > 1 ? "s" : "") + "."
//     }
// }
//
// skills["pull"] = {
//     "type": "attack",
//     "animation": "strike",
//     "range": CLOSE_RANGE,
//     "power": 1,
//     "canTarget": function({performerKey, stage, position}) {
//         const performer = stage.units[performerKey]
//         const target = findUnitAtPosition(stage, position)
//         if(target == undefined) return false
//         if(target.affiliation != performer.affiliation) return false
//         const previousPosition = performer.position
//         const direction = Geometry.direction(position, performer.position)
//         const nextDirection = Geometry.flip(direction)
//         const nextPosition = Geometry.add(previousPosition, nextDirection)
//         return hasCollision(stage, previousPosition, nextPosition) == false
//     },
//     "calculateDeltastages": function({performerKey, stage, position}) {
//         const performer = stage.units[performerKey]
//         const direction = Geometry.direction(position, performer.position)
//
//         const deltastages = []
//
//         // deltastages.push({
//         //     "annotation": {"type": "swing", "direction": direction},
//         //     "units": {[performer.key]: {}}
//         // })
//
//         const target = findUnitAtPosition(stage, position)
//
//         const previousPosition = performer.position
//         const nextDirection = Geometry.flip(direction)
//         const nextPosition = Geometry.add(previousPosition, nextDirection)
//
//         if(target != undefined
//         && hasCollision(stage, previousPosition, nextPosition) == false) {
//             deltastages.push({
//                 "annotation": {"type": "push", "direction": direction},
//                 "units": {
//                     [performer.key]: {"position": nextDirection},
//                     [target.key]: {"position": nextDirection},
//                 }
//             })
//             recalculateEffects(stage, target, deltastages[deltastages.length-1].units[target.key])
//             recalculateEffects(stage, target, deltastages[deltastages.length-1].units[performer.key])
//         }
//
//         return deltastages
//     },
//     "name": "Pull",
//     "description": "Pulls an ally backwards [1] tile.",
// }
//
// skills["swap"] = {
//     "type": "attack",
//     "animation": "strike",
//     "range": CLOSE_RANGE,
//     "power": 1,
//     // TODO: write a .canTarget like the other basic sumo moves?
//     "calculateDeltastages": function({performerKey, stage, position}) {
//         const performer = stage.units[performerKey]
//         const direction = Geometry.direction(position, performer.position)
//
//         const deltastages = []
//
//         // deltastages.push({
//         //     "annotation": {"type": "swing", "direction": direction},
//         //     "units": {[performer.key]: {}}
//         // })
//
//         const target = findUnitAtPosition(stage, position)
//
//         if(target == undefined) {
//             return deltastages
//         }
//
//         if(target != undefined) {
//             deltastages.push({
//                 "annotation": {"type": "push", "direction": Geometry.flip(direction)},
//                 "units": {[target.key]: {"position": Geometry.flip(direction)}}
//             })
//             recalculateEffects(stage, target, deltastages[deltastages.length-1].units[target.key])
//             deltastages.push({
//                 "annotation": {"type": "push", "direction": direction},
//                 "units": {[performer.key]: {"position": direction}}
//             })
//             recalculateEffects(stage, performer, deltastages[deltastages.length-1].units[performer.key])
//         }
//
//         return deltastages
//     },
//     "name": "Swap",
//     "description": "Trades positions with an ally.",
// }
//
// //////////////////
// // Olderschool //
// ////////////////
//
// // Prior to skill key as skill composition.
//
// skills["heal"] = {
//     "type": "attack",
//     "range": CLOSE_RANGE,
//     "power": 1,
//     "animation": "strike",
//     "calculateDeltastages": function({performerKey, stage, position}) {
//         const performer = stage.units[performerKey]
//         const direction = Geometry.direction(position, performer.position)
//
//         const deltastages = [
//             {
//                 "annotation": {"type": "swing", "direction": direction},
//                 "units": {
//                     [performerKey]: {},
//                 }
//             }
//         ]
//
//         const target = findUnitAtPosition(stage, position)
//         if(target != undefined
//         && target.health < target.maxhealth) {
//             deltastages.push({
//                 "annotation": {"type": "bump", "direction": direction},
//                 "units": {
//                     [target.key]: {
//                         "health": +1 * this.power,
//                     }
//                 }
//             })
//         }
//
//         return deltastages
//     },
//     "name": "Heal",
//     "description": "Restores (2) health.", // TODO: how to dynamically insert the power here?
//     "element": "normal",
// }
//
// skills["midrange-strike"] = {
//     "type": "attack",
//     "range": {
//         "min": 2,
//         "max": 2,
//         "orthogonal": true,
//         "diagonal": true,
//         "type": "arc",
//     },
//     "animation": "strike",
//     "calculateDeltastages": function({performerKey, stage, position}) {
//         const performer = stage.units[performerKey]
//         const direction = Geometry.direction(position, performer.position)
//
//         const deltastages = [
//             {
//                 "annotation": {"type": "swing", "direction": direction},
//                 "units": {
//                     [performerKey]: {},
//                 }
//             }
//         ]
//
//         const target = findUnitAtPosition(stage, position)
//         if(target != undefined) {
//             const baseDamage = -1 * (this.power + performer.power) || 0
//             const elementalDamage = Elements.getDamage(target.element, performer.element) // this.element // ??
//
//             deltastages.push({
//                 "units": {
//                     "annotation": {"type": "bump", "direction": direction},
//                     [target.key]: {
//                         "health": baseDamage + elementalDamage,
//                     }
//                 }
//             })
//         }
//
//         return deltastages
//     },
//     "name": "Strike",
//     "description": "Deals 1 damage.",
//     // "element": "fire",
//     "power": 1,
// }
//
// skills["longrange-strike"] = {
//     "type": "attack",
//     "animation": "farstrike",
//     "range": LONG_RANGE,
//     "calculateDeltastages": function({performerKey, stage, position}) {
//         const performer = stage.units[performerKey]
//         const direction = Geometry.direction(performer.position, position)
//
//         const deltastages = []
//
//         deltastages.push({
//             "annotation": {
//                 "type": "cast projectile",
//                 "unitKey": performer.key,
//                 "startPosition": performer.position,
//                 "endPosition": position,
//             },
//             "units": {}
//         })
//
//         const target = findUnitAtPosition(stage, position)
//         if(target != undefined) {
//             const baseDamage = -1 * (this.power + performer.power) || 0
//             const elementalDamage = Elements.getDamage(target.element, performer.element) // this.element
//             const damage = baseDamage + elementalDamage
//             deltastages.push({
//                 "annotation": {"type": "inflict damage", "direction": direction},
//                 "units": {[target.key]: {"health": damage}}
//             })
//         }
//
//         [{"x": +1}, {"x": -1}, {"y": +1}, {"y": -1}].forEach((direction) => {
//             const neighboringPosition = Geometry.add(position, direction)
//             if(World.hasCollision(stage.world, position, neighboringPosition)) {
//                 return
//             }
//             const unit = findUnitAtPosition(stage, neighboringPosition)
//             // TODO: Handle finding units adjacent but on a ramp.
//             if(unit == undefined) {
//                 return
//             }
//
//             const nextPosition = Geometry.add(unit.position, direction)
//             const collidingUnit = findUnitAtPosition(stage, nextPosition)
//             const collisionDamage = -1
//             if(collidingUnit != undefined) {
//                 deltastages.push({
//                     "annotation": {"type": "bump", "direction": direction},
//                     "units": {[unit.key]: {"health": collisionDamage}}
//                 })
//                 deltastages.push({
//                     "annotation": {"type": "bump-into", "direction": direction},
//                     "units": {[collidingUnit.key]: {"health": collisionDamage}}
//                 })
//             } else if(World.hasCollision(stage.world, unit.position, nextPosition)) {
//                 deltastages.push({
//                     "annotation": {"type": "bump", "direction": direction},
//                     "units": {[unit.key]: {"health": collisionDamage}}
//                 })
//             } else {
//                 deltastages.push({
//                     "annotation": {"type": "push", "direction": direction},
//                     "units": {[unit.key]: {"mode": "relative", "position": direction}}
//                 })
//                 recalculateEffects(stage, unit, deltastages[deltastages.length-1].units[unit.key]) // TODO: IS THIS WHERE WE'RE DOING ALL RE-CALCS?
//             }
//         })
//
//         return deltastages
//     },
//     "name": "Far Strike",
//     "description": "Deals 1 damage from far away, pushing adjacent units away.",
//     "power": 1,
// }
// skills["long-range-strike"] = skills["longrange-strike"]
//
// skills["charge"] = {
//     "type": "attack",
//     "animation": "charge",
//     "range": CLOSE_RANGE,
//     "calculateDeltastages": function({performerKey, stage, position}) {
//         const performer = stage.units[performerKey]
//         const direction = Geometry.direction(position, performer.position)
//
//         let chargeAmount = 0
//         let chargeVector = {"x": 0, "y": 0}
//         let chargePosition = Geometry.add(performer.position, chargeVector)
//         while(hasCollision(stage, chargePosition, Geometry.add(chargePosition, direction)) == false) {
//             chargeVector = Geometry.add(chargeVector, direction)
//             chargePosition = Geometry.add(chargePosition, direction)
//             chargeAmount += 1
//         }
//
//         const deltastages = []
//
//         deltastages.push({
//             "annotation": {"type": "charge", "distance": chargeAmount},
//             "units": {
//                 [performer.key]: {
//                     "position": chargeVector
//                 }
//             }
//         })
//
//         const collidingUnit = findUnitAtPosition(stage, Geometry.add(chargePosition, direction))
//         if(World.hasCollision(stage.world, chargePosition, Geometry.add(chargePosition, direction)) == false
//         && collidingUnit != undefined) {
//             const baseDamage = -1 * (this.power + performer.power) || 0
//             const elementalDamage = Elements.getDamage(collidingUnit.element, performer.element)
//             deltastages.push({
//                 "annotation": {"type": "inflict damage"},
//                 "units": {
//                     [collidingUnit.key]: {
//                         "health": baseDamage + elementalDamage
//                     }
//                 }
//             })
//
//             let rechargeAmount = 0
//             let rechargeVector = {"x": 0, "y": 0}
//             let rechargePosition = Geometry.add(collidingUnit.position, rechargeVector)
//             for(let i = 0; i < chargeAmount; i += 1) {
//                 // TODO: HANDLE CLIFFS AND RAMPS
//                 if(hasCollision(stage, rechargePosition, Geometry.add(rechargePosition, direction)) == false) {
//                     rechargeVector = Geometry.add(rechargeVector, direction)
//                     rechargePosition = Geometry.add(rechargePosition, direction)
//                     rechargeAmount += 1
//                     continue
//                 } else {
//                     // TODO: DO SOMETHING WITH COLLIDING UNIT, IF ANY
//                     const recollisionDamage = -1 * (chargeAmount - i)
//                     deltastages.push({
//                         "annotation": {"type": "inflict collision damage"},
//                         "units": {
//                             [collidingUnit.key]: {
//                                 "health": recollisionDamage
//                             }
//                         }
//                     })
//                     const recollidingUnit = findUnitAtPosition(stage, Geometry.add(collidingUnit.position, Geometry.add(rechargeVector, direction)))
//                     if(recollidingUnit) {
//                         deltastages.push({
//                             "annotation": {"type": "inflict collision damage"},
//                             "units": {
//                                 [recollidingUnit.key]: {
//                                     "health": recollisionDamage
//                                 }
//                             }
//                         })
//                     }
//                     break
//                 }
//             }
//             if(rechargeVector.x != 0
//             || rechargeVector.y != 0) {
//                 const deltastage = {
//                     "annotation": {"type": "push", "distance": rechargeAmount, "direction": direction},
//                     "units": {
//                         [collidingUnit.key]: {
//                             "position": rechargeVector
//                         }
//                     }
//                 }
//                 // recalculateEffects(stage, unit, deltastages[deltastages.length-1].units[unit.key])
//                 recalculateEffects(stage, collidingUnit, deltastage.units[collidingUnit.key])
//                 deltastages.push(deltastage)
//             }
//         }
//
//         return deltastages
//     },
//     "name": "Charge",
//     "description": "Deals 1 damage.",
//     "element": "ground",
//     "power": 1,
// }
//
// skills["lesser-charge"] = {
//     "type": "attack",
//     "animation": "charge",
//     "range": CLOSE_RANGE,
//     "calculateDeltastages": function({performerKey, stage, position}) {
//         const performer = stage.units[performerKey]
//         const direction = Geometry.direction(position, performer.position)
//
//         let chargeAmount = 0
//         let chargeVector = {"x": 0, "y": 0}
//         let chargePosition = Geometry.add(performer.position, chargeVector)
//         while(hasCollision(stage, chargePosition, Geometry.add(chargePosition, direction)) == false) {
//             chargeVector = Geometry.add(chargeVector, direction)
//             chargePosition = Geometry.add(chargePosition, direction)
//             chargeAmount += 1
//         }
//
//         const deltastages = []
//
//         deltastages.push({
//             "annotation": {"type": "charge", "distance": chargeAmount},
//             "units": {
//                 [performer.key]: {
//                     "position": chargeVector
//                 }
//             }
//         })
//
//         const collidingUnit = findUnitAtPosition(stage, Geometry.add(chargePosition, direction))
//         if(World.hasCollision(stage.world, chargePosition, Geometry.add(chargePosition, direction)) == false
//         && collidingUnit != undefined) {
//             const baseDamage = -1 * (this.power + performer.power) || 0
//             const elementalDamage = Elements.getDamage(collidingUnit.element, performer.element)
//             deltastages.push({
//                 "annotation": {"type": "inflict damage"},
//                 "units": {
//                     [collidingUnit.key]: {
//                         "health": baseDamage + elementalDamage
//                     }
//                 }
//             })
//
//             let rechargeAmount = 0
//             let rechargeVector = {"x": 0, "y": 0}
//             let rechargePosition = Geometry.add(collidingUnit.position, rechargeVector)
//             for(let i = 0; i < chargeAmount; i += 1) {
//                 // TODO: HANDLE CLIFFS AND RAMPS
//                 if(hasCollision(stage, rechargePosition, Geometry.add(rechargePosition, direction)) == false) {
//                     rechargeVector = Geometry.add(rechargeVector, direction)
//                     rechargePosition = Geometry.add(rechargePosition, direction)
//                     rechargeAmount += 1
//                     continue
//                 } else {
//                     // const recollisionDamage = -1 * (chargeAmount - i)
//                     const recollisionDamage = -1
//                     deltastages.push({
//                         "annotation": {"type": "inflict collision damage"},
//                         "units": {
//                             [collidingUnit.key]: {
//                                 "health": recollisionDamage
//                             }
//                         }
//                     })
//                     const recollidingUnit = findUnitAtPosition(stage, Geometry.add(collidingUnit.position, Geometry.add(rechargeVector, direction)))
//                     if(recollidingUnit) {
//                         deltastages.push({
//                             "annotation": {"type": "inflict collision damage"},
//                             "units": {
//                                 [recollidingUnit.key]: {
//                                     "health": recollisionDamage
//                                 }
//                             }
//                         })
//                     }
//                     break
//                 }
//             }
//             if(rechargeVector.x != 0
//             || rechargeVector.y != 0) {
//                 const deltastage = {
//                     "annotation": {"type": "push", "distance": rechargeAmount, "direction": direction},
//                     "units": {
//                         [collidingUnit.key]: {
//                             "position": rechargeVector
//                         }
//                     }
//                 }
//                 // recalculateEffects(stage, unit, deltastages[deltastages.length-1].units[unit.key])
//                 recalculateEffects(stage, collidingUnit, deltastage.units[collidingUnit.key])
//                 deltastages.push(deltastage)
//             }
//         }
//
//         return deltastages
//     },
//     "name": "Charge",
//     "description": "Deals 1 damage.",
//     "element": "ground",
//     "power": 1,
// }
//
// skills["swipe"] = {
//     "type": "attack",
//     "animation": "strike",
//     "range": CLOSE_RANGE,
//     "calculateDeltastages": function({performerKey, stage, position}) {
//         const performer = stage.units[performerKey]
//         const direction = Geometry.direction(position, performer.position)
//
//         const deltastages = []
//
//         deltastages.push({
//             "annotation": {"type": "swing", "direction": direction},
//             "units": {[performer.key]: {}}
//         })
//
//         const leftdirection = Geometry.perpendicular(direction)
//         const rightdirection = Geometry.flip(leftdirection)
//         const targets = [
//             findUnitAtPosition(stage, position),
//             findUnitAtPosition(stage, Geometry.add(position, leftdirection)),
//             findUnitAtPosition(stage, Geometry.add(position, rightdirection)),
//         ]
//
//         targets.forEach((target) => {
//             if(target == undefined) {
//                 return
//             }
//             const baseDamage = -1 * (this.power + performer.power) || 0
//             const elementalDamage = Elements.getDamage(target.element, performer.element) // this.element // ??
//
//             const deltastage = {
//                 "annotation": {"type": "bump", "direction": direction},
//                 "units": {
//                     [target.key]: {
//                         "health": baseDamage + elementalDamage,
//                     }
//                 }
//             }
//
//             if(hasCollision(stage, target.position, Geometry.add(target.position, direction))) {
//                 const collisionDamage = -1
//                 deltastage.units[target.key].health += collisionDamage
//                 const collidingUnit = findUnitAtPosition(stage, Geometry.add(target.position, direction))
//                 if(collidingUnit != undefined) {
//                     deltastage.units[collidingUnit.key] = deltastages[collidingUnit.key] || {}
//                     deltastage.units[collidingUnit.key].health = deltastages[collidingUnit.key].health || 0
//                     deltastage.units[collidingUnit.key].health += collisionDamage
//                 }
//             } else {
//                 deltastage.units[target.key].position = direction
//                 recalculateEffects(stage, target, deltastage.units[target.key]) // TODO: IS THIS WHERE WE'RE DOING ALL RE-CALCS?
//             }
//
//             deltastages.push(deltastage)
//         })
//
//         return deltastages
//     },
//     "name": "Swipe",
//     "description": "Attacks 3 tiles. Deals 1 damage and pushes 1 tile to each.",
//     "element": "ground",
//     "power": 1,
// }
//
// skills["rockthrow"] = {
//     "type": "attack",
//     "range": CLOSE_RANGE,
//     "animation": "rockthrow",
//     "calculateDeltastages": function({performerKey, stage, position}) {
//         const performer = stage.units[performerKey]
//         const direction = Geometry.direction(position, performer.position)
//
//         const id = stage.idgen || shortid.generate
//
//         const deltastages = []
//
//         deltastages.push({
//             "annotation": {"type": "swing", "direction": direction},
//             "units": {[performer.key]: {}}
//         })
//
//         const cast = raycast({
//             "stage": stage,
//             "position": performer.position,
//             "direction": direction
//         })
//
//         if(cast.ray.distance > 0) {
//             const position = cast.ray.endPosition
//             // TODO: Initialize all this with a Unit utility function
//             const token = {
//                 "mode": "create",
//                 "key": "unit:" + id(),
//                 "position": position,
//                 "health": 1,
//                 "maxhealth": 1,
//                 "element": "neutral",
//                 "number": 0,
//                 "name": 0,
//                 "reference": 0,
//                 // "image": require("@frog/source/assets/images/pokemon/oakdex/000.png"),
//                 "image": "https://frog-tactics.s3-us-west-2.amazonaws.com" + "/assets/images/pokemon/oakdex/000.png",
//                 "moverange": 1,
//                 "affiliation": "none",
//                 "skills": [],
//                 "energy": {"move": false, "invoke skill": false},
//                 "power": 0,
//             }
//             deltastages.push({
//                 "annotation": {"type": "throw", "startPosition": cast.ray.startPosition, "vector": cast.ray.vector},
//                 "units": {
//                     [token.key]: token
//                 }
//             })
//         }
//
//         if(cast.collision != undefined
//         && cast.collision.unit != undefined) {
//             deltastages.push({
//                 "type": "bump",
//                 "units": {
//                     [cast.collision.unit.key]: {
//                         "health": -1 // ELEMENTAL DAMAGE?
//                     }
//                 }
//             })
//         }
//
//         return deltastages
//     },
//     "name": "Strike",
//     "description": "Deals 1 damage.",
//     // "element": "fire",
//     "power": 1,
// }
//
// skills["throw-bomb"] = {
//     "type": "attack",
//     "range": CLOSE_RANGE,
//     "animation": "rockthrow",
//     "calculateDeltastages": function({performerKey, stage, position}) {
//         const performer = stage.units[performerKey]
//         const direction = Geometry.direction(position, performer.position)
//
//         const id = stage.idgen || shortid.generate
//
//         const deltastages = []
//
//         deltastages.push({
//             "annotation": {"type": "swing", "direction": direction},
//             "units": {[performer.key]: {}}
//         })
//
//         const cast = raycast({
//             "stage": stage,
//             "position": performer.position,
//             "direction": direction
//         })
//
//         if(cast.ray.distance > 0) {
//             const position = cast.ray.endPosition
//             // TODO: Initialize all this with a Unit utility function
//             const token = {
//                 "mode": "create",
//                 "key": "unit:" + id(),
//                 "position": position,
//                 "health": 1,
//                 "maxhealth": 1,
//                 "element": "neutral",
//                 "number": 0,
//                 "name": 0,
//                 "reference": 0,
//                 // "image": require("@frog/source/assets/images/pokemon/oakdex/100.png"),
//                 "image": "https://frog-tactics.s3-us-west-2.amazonaws.com" + "/assets/images/pokemon/oakdex/100.png",
//                 "moverange": 1,
//                 "affiliation": "none",
//                 "skills": [],
//                 "effects": [
//                     {"type": "fuse", "timer": 2, "skillKey": "explode"}
//                 ],
//                 "energy": {"move": false, "invoke skill": false},
//                 "power": 0,
//             }
//             deltastages.push({
//                 "annotation": {"type": "throw", "startPosition": cast.ray.startPosition, "vector": cast.ray.vector},
//                 "units": {
//                     [token.key]: token
//                 }
//             })
//         }
//
//         // if(cast.collision != undefined
//         // && cast.collision.unit != undefined) {
//         //     deltastages.push({
//         //         "type": "bump",
//         //         "units": {
//         //             [cast.collision.unit.key]: {
//         //                 "health": -1 // ELEMENTAL DAMAGE?
//         //             }
//         //         }
//         //     })
//         // }
//
//         return deltastages
//     },
//     "name": "Strike",
//     "description": "Deals 1 damage.",
//     // "element": "fire",
//     "power": 1,
// }
//
// skills["toss-bomb"] = {
//     "type": "attack",
//     "animation": "farstrike",
//     "range": LONG_RANGE,
//     "power": 1,
//     "timer": 2,
//     "canTarget": function({performerKey, stage, position}) {
//         return findUnitAtPosition(stage, position) == undefined
//     },
//     "calculateDeltastages": function({performerKey, stage, position}) {
//         const performer = stage.units[performerKey]
//
//         const deltastages = []
//
//         deltastages.push({
//             "annotation": {
//                 "type": "cast projectile",
//                 "unitKey": performer.key,
//                 "startPosition": performer.position,
//                 "endPosition": position,
//             }
//         })
//
//         const power = this.power // + performer.power
//
//         const range = {
//             "min": 0,
//             "max": power,
//             "orthogonal": true,
//             "diagonal": false,
//         }
//         // TODO: Initialize this with Unit!! And only put here what you need to put here.
//         const id = stage.idgen || shortid.generate
//         const token = {
//             "mode": "create",
//             "key": "unit:" + id(),
//             "position": position,
//             "health": 1,
//             "maxhealth": 1,
//             "element": "neutral",
//             "number": 0,
//             "name": 0,
//             "reference": "voltorb",
//             // "image": require("@frog/source/assets/images/pokemon/oakdex/100.png"),
//             "image": "https://frog-tactics.s3-us-west-2.amazonaws.com" + "/assets/images/pokemon/oakdex/" + (power >= 2 ? "101" : "100") + ".png",
//             "moverange": 1,
//             "affiliation": "none",
//             "skills": [],
//             "effects": {
//                 "fuse": {
//                     "type": "fuse",
//                     "timer": this.timer || 2,
//                     "skillKey": "explode"
//                 },
//                 "range": {
//                     "timer": this.timer || 2,
//                     "type": "traplike",
//                     "range": range,
//                     "positions": calculateTrapPositions({
//                         "stage": stage,
//                         "range": range,
//                         "position": position,
//                     }),
//                 }
//             },
//             "energy": {"move": false, "invoke skill": false},
//             "power": power,
//         }
//         deltastages.push({
//             "units": {[token.key]: token}
//         })
//
//         return deltastages
//     },
//     "name": function() {
//         if(this.power >= 2) return "Throw Big Bomb!!"
//         return "Throw Bomb"
//     },
//     "description": function() {
//         if(this.power >= 2) return "Throws a bomb. It explodes at the start of your next turn... for 2 tiles!"
//         return "Throws a bomb. It explodes at the start of your next turn."
//         // return "Toss a bomb [" + this.range.max + "] tiles away. It explodes at the start of your next turn."
//     }
// }
//
// skills["explode"] = {
//     "type": "from-effect",
//     "animation": "explode",
//     "calculateStep": function({stage, performerKey, effectKey, position}) {
//         const step = Step.instantiate({"alphastage": stage})
//
//         const performer = step.omegastage.units[performerKey]
//         const explosions = [{"position": position, "power": performer.power, "directions": directions}]
//         const hasExploded = {}
//         while(explosions.length > 0) {
//             const explosion = explosions.shift()
//             explosion.distance = explosion.distance || 0
//
//             if(World.hasCollision(stage.world, explosion.position, explosion.position)) {
//                 continue
//             }
//             hasExploded[Geometry.toString(explosion.position)] = explosion
//
//             const unit = findUnitAtPosition(stage, explosion.position)
//             if(unit != undefined) {
//                 if(unit.reference == "voltorb" // IS BOMB // TODO: I wish there was a better type indicator what is this unity lol
//                 && unit.key != performerKey) {
//                     explosion.power = Math.max(explosion.power, unit.power)
//                     explosion.directions = directions.filter((direction) => Geometry.equals(direction, Geometry.flip(explosion.directions[0])) == false)
//                 }
//                 // Do not pierce through boxes.
//                 if(unit.family == "box") { // IS SOFT BOX BLOCK
//                     explosion.power = 0
//                 }
//                 // destroy the unit or box or bomb.
//                 explosion.unit = unit
//             }
//
//             if(explosion.power > 0) {
//                 explosion.directions.forEach((direction) => {
//                     const nextPosition = Geometry.add(explosion.position, direction)
//                     if(hasExploded[Geometry.toString(nextPosition)] != undefined) return
//                     explosions.push({
//                         "power": explosion.power - 1,
//                         "distance": explosion.distance + 1,
//                         "directions": [direction],
//                         "position": nextPosition
//                     })
//                 })
//             }
//         }
//
//         Keyset.forEach(hasExploded, (explosion) => {
//             Step.add(step, {"annotation": {"type": "explode", "position": explosion.position, "distance": explosion.distance}})
//             if(explosion.unit != undefined) {
//                 Step.add(step, {"annotation": {"type": "remove", "distance": explosion.distance}, "units": {[explosion.unit.key]: {"health": -100, "isDead": true}}})
//             }
//         })
//
//         return step
//     },
// }
//
// // TODO: consider a less descendant heavy schema
// // ["units." + perforemrKey + ".isDead"]: true
// // "key": ["units", performerKey", "isDead"], "value": true
//
// skills["readytrap"] = {
//     "type": "attack",
//     "range": CLOSE_RANGE,
//     "animation": "readytrap",
//     "calculateDeltastages": function({performerKey, stage, position}) {
//         const performer = stage.units[performerKey]
//         const direction = Geometry.direction(position, performer.position)
//
//         // const collidingUnit = findUnitAtPosition(stage, Geometry.add(performer.position, Geometry.add(chargeVector, direction)))
//         // if(collidingUnit != undefined) {
//         //     // THIS IS A PRE-TRIPPED TRAP!!
//         // }
//
//         const range = {
//             "min": 1,
//             "max": 7,
//             "directions": [direction],
//             "type": "line",
//         }
//
//         return [
//             {
//                 "annotation": {"type": "attacking", "unitKey": performer.key, "direction": direction}
//             },
//             {
//                 "annotation": {"type": "readying-trap"},
//                 "units": {
//                     [performer.key]: {
//                         "effects": [
//                             {
//                                 "timer": 2,
//                                 "type": "trap",
//                                 // ...
//                                 "range": range,
//                                 "skillKey": "trapstrike",
//                                 "positions": calculateTrapPositions({
//                                     "stage": stage,
//                                     "range": range,
//                                     "position": performer.position,
//                                 }),
//                             }
//                         ]
//                     }
//                 }
//             }
//         ]
//     },
//     "name": "Ready Trap",
//     "description": "Lays a trap!",
//     // "element": "fire",
//     "power": 1,
// }
//
// skills["trapstrike"] = {
//     "key": "trapstrike",
//     "type": "attack",
//     "range": CLOSE_RANGE,
//     "animation": "readytrap", // ??????
//     "calculateDeltastages": function({performerKey, effectKey, stage, position}) {
//         const performer = stage.units[performerKey]
//         const target = findUnitAtPosition(stage, position)
//         const direction = Geometry.direction(position, performer.position)
//
//         const deltastage = {
//             "units": {
//                 [performer.key]: {
//                     "effects": {
//                         [effectKey]: undefined
//                     }
//                 }
//             }
//         }
//
//         if(target != undefined) {
//             const baseDamage = -3
//             const elementalDamage = Elements.getDamage(target.element, performer.element) // this.element // ??
//
//             deltastage.units[target.key] = {
//                 "health": baseDamage + elementalDamage,
//                 "effects": {
//                     "flinch": {"type": "flinch", "timer": 1}
//                 }
//             }
//         }
//
//         return [
//             {"annotation": {"type": "attacking", "unitKey": performerKey, "direction": direction}},
//             {"annotation": {"type": "trigger-trap"}, "units": deltastage.units}
//         ]
//     },
//     "name": "Strike",
//     "description": "Deals 1 damage.",
//     // "element": "fire",
//     "power": 1,
// }
//
// skills["leap"] = {
//     "type": "attack",
//     "animation": "leap",
//     "range": LONG_RANGE,
//     "canTarget": function({performerKey, stage, position}) {
//         return findUnitAtPosition(stage, position) == undefined
//     },
//     "calculateDeltastages": function({performerKey, stage, position}) {
//         const performer = stage.units[performerKey]
//         const vector = Geometry.difference(position, performer.position)
//
//         const deltastages = []
//
//         deltastages.push({
//             "annotation": {
//                 "type": "leap",
//                 "unitKey": performer.key,
//                 "vector": vector
//                 // "startPosition": performer.position,
//                 // "endPosition": position,
//             },
//             "units": {
//                 [performer.key]: {
//                     "position": vector,
//                 }
//             }
//         })
//
//         directions.forEach((direction) => {
//             const neighboringPosition = Geometry.add(position, direction)
//             if(World.hasCollision(stage.world, position, neighboringPosition)) {
//                 return
//             }
//             const neighboringUnit = findUnitAtPosition(stage, neighboringPosition)
//             if(neighboringUnit == undefined) return
//             const baseDamage = -1 * (this.power + performer.power) || 0
//             const elementalDamage = Elements.getDamage(neighboringUnit.element, performer.element) // this.element
//             const damage = baseDamage + elementalDamage
//             deltastages.push({
//                 "annotation": {"type": "bump", "direction": direction},
//                 "units": {[neighboringUnit.key]: {"health": damage}}
//             })
//         })
//
//         return deltastages
//     },
//     "name": "Leap",
//     "description": "Jump to a tile, damaging neighboring tiles.",
//     "power": 1,
// }
//
// skills["shock"] = {
//     "type": "attack",
//     "animation": "shock",
//     "range": CLOSE_RANGE,
//     "calculateDeltastages": function({performerKey, stage, position}) {
//         const performer = stage.units[performerKey]
//         const direction = Geometry.direction(position, performer.position)
//
//         const deltastages = []
//         // deltastages.push({
//         //     "annotation": {"type": "swing", "direction": direction},
//         //     "units": {[performerKey]: {}}
//         // })
//
//         const shockMap = {}
//         const shockQueue = []
//         shockQueue.push(shockMap[Geometry.toString(performer.position)] = {
//             "position": performer.position,
//             "distance": 0,
//         })
//
//         while(shockQueue.length > 0) {
//             const currentShock = shockQueue.pop()
//
//             currentShock.unit = findUnitAtPosition(stage, currentShock.position)
//             if(currentShock.unit == undefined) continue
//
//             directions.forEach((direction) => {
//                 const nextPosition = Geometry.add(currentShock.position, direction)
//                 if(World.hasCollision(stage.world, currentShock.position, nextPosition) == true) return
//                 const nextPositionKey = Geometry.toString(nextPosition)
//                 if(shockMap[nextPositionKey] != undefined) {
//                     if(shockMap[nextPositionKey].distance > currentShock.distance + 1) {
//                         shockMap[nextPositionKey] = currentShock.distance + 1
//                     }
//                     return
//                 }
//                 shockQueue.push(shockMap[nextPositionKey] = {
//                     "distance": currentShock.distance + 1,
//                     "position": nextPosition,
//                 })
//             })
//         }
//
//         Keyset.forEach(shockMap, (shock) => {
//             if(shock.unit != undefined) {
//                 deltastages.push({
//                     "annotation": {"type": "shock", "distance": shock.distance},
//                     "units": {
//                         [shock.unit.key]: {
//                             "health": -1 // ELEMENTAL DAMAGE
//                         }
//                     }
//                 })
//             }
//         })
//
//         return deltastages
//     },
//     "name": "Shock",
//     "description": ".",
//     "power": 1,
// }
//
// skills["midrange-counterattack"] = {
//     "type": "counterattack",
//     "range": MID_RANGE,
//     "animation": "strike",
//     "calculateDeltastages": function({performerKey, stage, position}) {
//         const performer = stage.units[performerKey]
//         const direction = Geometry.direction(position, performer.position)
//
//         const deltastages = []
//         deltastages.push({
//             "annotation": {"type": "swing", "direction": direction},
//             "units": {[performerKey]: {}}
//         })
//
//         const target = findUnitAtPosition(stage, position)
//         if(target != undefined) {
//             const baseDamage = -1 * (this.power + performer.power) || 0
//             const elementalDamage = Elements.getDamage(target.element, performer.element) // this.element // ??
//
//             deltastages.push({
//                 "annotation": {"type": "bump", "direction": direction},
//                 "units": {[target.key]: {"health": baseDamage + elementalDamage}}
//             })
//         }
//
//         return deltastages
//     },
//     "name": "Counterstrike",
//     "description": "Deals 1 damage.",
//     "power": 1,
// }
//
// skills["midrange"] = {
//     "type": "attack",
//     "range": MID_RANGE,
//     "animation": "strike",
//     "calculateDeltastages": function({performerKey, stage, position}) {
//         const performer = stage.units[performerKey]
//         const direction = Geometry.direction(position, performer.position)
//
//         const deltastages = [
//             {
//                 "annotation": {"type": "swing", "direction": direction},
//                 "units": {[performerKey]: {}}
//             }
//         ]
//
//         const target = findUnitAtPosition(stage, position)
//         if(target != undefined) {
//             const baseDamage = -1 * (this.power + performer.power) || 0
//             const elementalDamage = Elements.getDamage(target.element, performer.element) // this.element // ??
//
//             deltastages.push({
//                 "units": {
//                     "annotation": {"type": "bump", "direction": direction},
//                     [target.key]: {
//                         "health": baseDamage + elementalDamage,
//                     }
//                 }
//             })
//         }
//
//         return deltastages
//     },
//     "name": "Mid Strike",
//     "description": "Deals 1 damage.",
//     // "element": "fire",
//     "power": 1,
// }
//
// // deleted: leap over
// // deleted: swap
// // deleted: cut-through
